import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function fileUrl(path) {
  if (!path) return "";
  return `${API_BASE}/files/${path}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CONTACT_PHONE = "(586) 306-8449";
export const CONTACT_PHONE_TEL = "+15863068449";
export const ZELLE_EMAIL = "stressfreeaging@gmail.com";

export const CARE_TYPES = [
  { value: "drop_in", label: "Emergency Drop-In" },
  { value: "weekly_respite", label: "Weekly Respite" },
  { value: "long_term_respite", label: "Long-Term Respite" },
  { value: "trial_visit", label: "Trial Visit (Before Placement)" },
  { value: "hospice_respite", label: "Daily Hospice Respite (24-hr / no long-term commitment)" },
];

export const FACILITY_TYPES = [
  { value: "adult_foster_care", label: "Adult Foster Care Home" },
  { value: "senior_living", label: "Senior Living Community" },
  { value: "memory_care", label: "Memory Care Community" },
  { value: "group_home", label: "Group Home" },
];

export const SPECIALTIES = [
  { value: "memory_care", label: "Memory Care" },
  { value: "secured_memory_care", label: "Secured Memory Care" },
  { value: "parkinsons", label: "Parkinson's Care" },
  { value: "autism", label: "Autism / Adults on the Spectrum" },
  { value: "idd", label: "IDD (Intellectual & Developmental Disabilities)" },
  { value: "hospice_certified", label: "Hospice Certified (end-of-life care)" },
];

export const CARE_NEEDS = [
  { value: "memory_care", label: "Memory Care" },
  { value: "mild_dementia", label: "Mild Dementia" },
  { value: "alzheimers", label: "Alzheimer's" },
  { value: "parkinsons", label: "Parkinson's" },
  { value: "autism", label: "Autism / Adults on the Spectrum" },
  { value: "idd", label: "IDD (Intellectual & Developmental Disabilities)" },
  { value: "fall_risk", label: "Fall Risk" },
  { value: "wheelchair", label: "Wheelchair" },
  { value: "hospice_friendly", label: "Hospice Friendly" },
];

export const FINANCIAL = [
  { value: "private_pay", label: "Private Pay" },
  { value: "va_benefits", label: "VA Benefits Accepted" },
  { value: "medicaid_waiver", label: "Medicaid Waiver" },
  { value: "ltc_insurance", label: "Long-Term Care Insurance" },
];

export const AVAILABILITY = [
  { value: "immediate_opening", label: "Immediate Opening" },
  { value: "day_visit", label: "Day Visit Available" },
  { value: "respite", label: "Respite Available" },
  { value: "trial_stay", label: "Trial Stay Available" },
];

const _ALL = [...CARE_NEEDS, ...FINANCIAL, ...AVAILABILITY, ...SPECIALTIES];
export function tagLabel(v) {
  return _ALL.find((x) => x.value === v)?.label || v;
}

export const US_STATES = [
  { code: "AL", name: "Alabama" }, { code: "AK", name: "Alaska" }, { code: "AZ", name: "Arizona" },
  { code: "AR", name: "Arkansas" }, { code: "CA", name: "California" }, { code: "CO", name: "Colorado" },
  { code: "CT", name: "Connecticut" }, { code: "DE", name: "Delaware" }, { code: "FL", name: "Florida" },
  { code: "GA", name: "Georgia" }, { code: "HI", name: "Hawaii" }, { code: "ID", name: "Idaho" },
  { code: "IL", name: "Illinois" }, { code: "IN", name: "Indiana" }, { code: "IA", name: "Iowa" },
  { code: "KS", name: "Kansas" }, { code: "KY", name: "Kentucky" }, { code: "LA", name: "Louisiana" },
  { code: "ME", name: "Maine" }, { code: "MD", name: "Maryland" }, { code: "MA", name: "Massachusetts" },
  { code: "MI", name: "Michigan" }, { code: "MN", name: "Minnesota" }, { code: "MS", name: "Mississippi" },
  { code: "MO", name: "Missouri" }, { code: "MT", name: "Montana" }, { code: "NE", name: "Nebraska" },
  { code: "NV", name: "Nevada" }, { code: "NH", name: "New Hampshire" }, { code: "NJ", name: "New Jersey" },
  { code: "NM", name: "New Mexico" }, { code: "NY", name: "New York" }, { code: "NC", name: "North Carolina" },
  { code: "ND", name: "North Dakota" }, { code: "OH", name: "Ohio" }, { code: "OK", name: "Oklahoma" },
  { code: "OR", name: "Oregon" }, { code: "PA", name: "Pennsylvania" }, { code: "RI", name: "Rhode Island" },
  { code: "SC", name: "South Carolina" }, { code: "SD", name: "South Dakota" }, { code: "TN", name: "Tennessee" },
  { code: "TX", name: "Texas" }, { code: "UT", name: "Utah" }, { code: "VT", name: "Vermont" },
  { code: "VA", name: "Virginia" }, { code: "WA", name: "Washington" }, { code: "WV", name: "West Virginia" },
  { code: "WI", name: "Wisconsin" }, { code: "WY", name: "Wyoming" }, { code: "DC", name: "District of Columbia" },
];

export const STATE_SLUG_TO_CODE = US_STATES.reduce((acc, s) => {
  acc[s.name.toLowerCase().replace(/\s+/g, "-")] = s.code;
  return acc;
}, {});

export const STATE_CODE_TO_NAME = US_STATES.reduce((acc, s) => {
  acc[s.code] = s.name;
  return acc;
}, {});

export function stateSlug(name) {
  return name.toLowerCase().replace(/\s+/g, "-");
}

export function careTypeLabel(v) {
  return CARE_TYPES.find((c) => c.value === v)?.label || v;
}
export function facilityTypeLabel(v) {
  return FACILITY_TYPES.find((f) => f.value === v)?.label || v;
}
export function specialtyLabel(v) {
  return SPECIALTIES.find((s) => s.value === v)?.label || v;
}
